import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

export default createStore({
  state: {
    user: null,
    saltKey: "haydaHobbaGizliKey!456?",
    schema: [], 
    library_settings: [], 
    book_loans: [], 
    library_books: [], 
    students: [], 
    schools: [], 
    libraries: [], 
    books: [], 
    contacts: [],
    tasks: [],
    reports: [],
  },
  mutations: {
    setUser(state, user) {
      console.log("user :>> ", user);
      state.user = user;
    },
    logoutUser(state) {
      state.user = null;
    },
    addContacts(state, contacts) { 
      state.contacts = [...contacts]; 
    }, 
    addBooks(state, books) { 
      state.books = [...books]; 
    }, 
    addLibraries(state, libraries) { 
      state.libraries = [...libraries]; 
    }, 
    addSchools(state, schools) { 
      state.schools = [...schools]; 
    }, 
    addStudents(state, students) { 
      state.students = [...students]; 
    }, 
    addLibrary_books(state, library_books) { 
      state.library_books = [...library_books]; 
    }, 
    addBook_loans(state, book_loans) { 
      state.book_loans = [...book_loans]; 
    }, 
    addLibrary_settings(state, library_settings) { 
      state.library_settings = [...library_settings]; 
    }, 
    addSchema(state, schema) {
      state.schema = [...schema];
    },
    addTasks(state, tasks) {
      state.tasks = [...tasks];
    },
    addReports(state, reports) {
      state.reports = [...reports];
    },
  },
  getters: {
    _isAuthenticated: (state) => state.user !== null,
    _getCurrentUser(state) {
      const user = state.user;

      delete user?.password;
      return user;
    },
    _currentUserId: (state) => state?.user?.id,
    _getCurrentRole: (state) => parseInt(state?.user?.role),
    _saltKey: (state) => state.saltKey,
    _getContacts: (state) => state?.contacts, 
    _getBooks: (state) => state?.books, 
    _getLibraries: (state) => state?.libraries, 
    _getSchools: (state) => state?.schools, 
    _getStudents: (state) => state?.students, 
    _getLibrary_books: (state) => state?.library_books, 
    _getBook_loans: (state) => state?.book_loans, 
    _getLibrary_settings: (state) => state?.library_settings, 
    _getSchema: (state) => state?.schema,
    _getTasks: (state) => state?.tasks,
    _getReports: (state) => state?.reports,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
